import { render, staticRenderFns } from "./PasswordChangeForm.vue?vue&type=template&id=15aa0ca0"
import script from "./PasswordChangeForm.vue?vue&type=script&lang=js"
export * from "./PasswordChangeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports